export const announcementTypeValues = [
  {
    value: "confirmation",
    label: "Confirmation",
  },
  {
    value: "information",
    label: "Information",
  },
  {
    value: "attention",
    label: "Attention",
  },
  {
    value: "warning",
    label: "Warning",
  },
];
